









































































































































































import { Component, Watch } from "vue-property-decorator";
import { BookingWizardModule } from "@/store/modules/bookingWizard";
import BookingRoleViewModel from "@/models/BookingRoles/BookingRoleViewModel";
import BookingWizardBookingRoleCreate from "@/components/BookingRoles/BookingWizardBookingRoleCreate.vue";
import BookingWizardBookingRoleEdit from "@/components/BookingRoles/BookingWizardBookingRoleEdit.vue";
import ShiftViewModel from "@/models/Shifts/ShiftViewModel";
import { VuetifyConfirmObject } from "vuetify-confirm";
import GiganautVueForm from "@/components/Shared/GiganautVueForm";
import ContactLocationDto from "@/models/ContactLocations/ContactLocationDto";
import DepartmentDto from "@/models/Departments/DepartmentDto";
import LocationDto from "@/models/Locations/LocationDto";
import { AppModule } from "@/store/modules/app";

@Component({
  name: "BookingWizardDetails",
  components: { BookingWizardBookingRoleCreate, BookingWizardBookingRoleEdit },
})
export default class BookingWizardDetails extends GiganautVueForm {
  //showMenu: false;
  name = "";
  datesFailedValidation = false;
  departments: DepartmentDto[] = [];
  currentLocation: LocationDto = new LocationDto();

  async validateForm() {
    return !(this.$refs.form as any).validate();
  }
  async validateDatesFailed(failed: boolean) {
    this.datesFailedValidation = failed;
  }

  isAdmin() {
    return AppModule.userProfile.isAdministrator;
  }

  get dates() {
    return BookingWizardModule.newBooking.dates;
  }

  set dates(value) {
    BookingWizardModule.updateNewBookingDates(value);
  }

  get branches() {
    return BookingWizardModule.newBookingOptions.branches;
  }

  get locations() {
    return BookingWizardModule.newBookingOptions.locations;
  }

  get agencyUsers() {
    return BookingWizardModule.newBookingOptions.agencyUsers;
  }

  get currentBranch() {
    return BookingWizardModule.newBooking.branch;
  }

  set currentBranch(value) {
    BookingWizardModule.updateNewBookingBranch(value);
  }

  get currentOwner() {
    return BookingWizardModule.newBooking.owner;
  }

  set currentOwner(value) {
    BookingWizardModule.updateNewBookingOwner(value);
  }

  //   get currentContact() {
  //     return BookingWizardModule.newBooking.contactLocation;
  //   }

  //   set currentContact(contactLocation: ContactLocationDto) {
  //     BookingWizardModule.updateNewBookingContact(contactLocation);
  //   }

  @Watch("currentLocation")
  async onCurrentLocationChanged(newVal: LocationDto, oldVal: LocationDto) {
    this.departments = newVal.departments;
    BookingWizardModule.updateNewBookingLocation(newVal);
  }

  get currentDepartment() {
    return BookingWizardModule.newBooking.department;
  }

  set currentDepartment(value) {
    BookingWizardModule.updateNewBookingDepartment(value);
  }

  get isTest() {
    return BookingWizardModule.newBooking.isTest;
  }

  set isTest(value) {
    BookingWizardModule.updateNewBookingIsTest(value);
  }

  get testEmailAddresses() {
    return BookingWizardModule.newBooking.testEmailAddresses;
  }

  set testEmailAddresses(value) {
    BookingWizardModule.updateNewBookingTestEmailAddresses(value);
  }

  get loading() {
    return BookingWizardModule.loading;
  }
}
